if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Function to initialize the first tab and table
function initializeFirstTabAndTable() {
    // Prioritize inches table if it exists, otherwise use first available
    const inchesTab = document.querySelector('[data-size="size-table-in"]');
    const inchesTable = document.querySelector('.size-table-in');
    const firstTab = document.querySelector('.size-table-tab');
    const firstTable = document.querySelector('.size-table-wrap');
    
    // Hide all tables first
    document.querySelectorAll('.size-table-wrap').forEach(table => {
        table.style.display = 'none';
    });
    
    // Remove active class from all tabs
    document.querySelectorAll('.size-table-tab').forEach(tab => {
        tab.classList.remove('size-table-active');
    });
    
    // Prioritize inches table
    if (inchesTab && inchesTable) {
        inchesTab.classList.add('size-table-active');
        inchesTable.style.display = 'block';
    } else if (firstTab && firstTable) {
        firstTab.classList.add('size-table-active');
        firstTable.style.display = 'block';
    }
}

// Function to handle tab clicks
function handleTabClick(event) {
    if (event.target.matches('.size-table-tab')) {
        const allTables = document.querySelectorAll('.tables > div');
        const allTabs = document.querySelectorAll('.size-table-tab');
        allTables.forEach(table => {
            table.style.display = 'none';
        });
        allTabs.forEach(tab => {
            tab.classList.remove('size-table-active');
        });

        const size = event.target.getAttribute('data-size');
        const targetTable = document.querySelector('.' + size);
        if (targetTable) {
            targetTable.style.display = 'block';
        }
        event.target.classList.add('size-table-active');
    }
}

// Function to handle accordion clicks
function handleAccordionClick(event) {
    if (event.target.matches('.accordion-header')) {
        const content = event.target.nextElementSibling;
        event.target.classList.toggle('active');

        if (content.classList.contains('active')) {
            content.classList.remove('active');
        } else {
            document.querySelectorAll('.accordion-content.active').forEach(function(openContent) {
                openContent.classList.remove('active');
                openContent.previousElementSibling.classList.remove('active');
            });
            content.classList.add('active');
        }
    }
}

function setupSizingWrap() {
    const sizingWrap = document.querySelector('.sizing-wrap');
    const sizingInner = document.querySelector('.sizing-wrap-inner');

    if (sizingWrap) {
        sizingWrap.addEventListener('click', function(event) {
            if (!sizingInner.contains(event.target)) {
                closeSizingWrap();
            }
        });
    }
}

function openSizingWrap() {
    const sizingWrap = document.querySelector('.sizing-wrap');
    const inchesTable = document.querySelector('.size-table-in');
    const inchesTab = document.querySelector('[data-size="size-table-in"]');
    const cmTable = document.querySelector('.size-table-cm');
    const cmTab = document.querySelector('[data-size="size-table-cm"]');
    
    if (sizingWrap) {
        sizingWrap.style.display = 'block';
        document.body.classList.add('overflow-hidden');
        
        // Hide all tables first
        document.querySelectorAll('.size-table-wrap').forEach(table => {
            table.style.display = 'none';
        });

        // Remove .size-table-active from all tabs
        document.querySelectorAll('.size-table-tab').forEach(tab => {
            tab.classList.remove('size-table-active');
        });
        
        // Prioritize inches table, fallback to CM
        if (inchesTable && inchesTab) {
            inchesTable.style.display = 'block';
            inchesTab.classList.add('size-table-active');
        } else if (cmTable && cmTab) {
            cmTable.style.display = 'block';
            cmTab.classList.add('size-table-active');
        }
    }
}

function closeSizingWrap() {
    const sizingWrap = document.querySelector('.sizing-wrap');
    
    if (sizingWrap) {
        sizingWrap.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
    }
}

// Main initialization
document.addEventListener('DOMContentLoaded', function() {
    initializeFirstTabAndTable();
    setupSizingWrap();

    // Event delegation for dynamically added elements
    document.body.addEventListener('click', function(event) {
        handleTabClick(event);
        handleAccordionClick(event);
        
        // Handle .size-chart-toggle
        if (event.target.matches('.size-chart-toggle')) {
            event.preventDefault();
            openSizingWrap();
        }
        
        // Handle .sizing-close
        if (event.target.matches('.sizing-close')) {
            event.preventDefault();
            closeSizingWrap();
        }
    });
});